import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tooltip.scss';

/* eslint-disable react/no-unknown-property */
function Tooltip(props) {
    return (
        <span
            className={styles[`tooltip-${props.type}`]}
            tooltip-position={props.position}
            tooltip-content={props.content}
        >
            {props.children}
        </span>
    );
}

export default Tooltip;
Tooltip.propTypes = {
    content: PropTypes.string,
    type: PropTypes.oneOf(['single', 'small', 'medium', 'large']),
    position: PropTypes.oneOf(['top', 'left', 'bottom', 'right']),
    children: PropTypes.node,
};
Tooltip.defaultProps = {
    content: '',
    position: 'top',
    type: 'small',
    children: null,
};
